import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "p-grid p-jc-center p-ai-center p-flex-column",
  style: {"min-height":"50vh"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "p-p-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "218",
    height: "187",
    viewBox: "0 0 218 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M196.801 101.696H189.755C189.529 101.696 189.345 101.536 189.345 101.338V100.93C189.345 100.733 189.529 100.572 189.755 100.572H196.801C197.027 100.572 197.211 100.733 197.211 100.93V101.338C197.211 101.536 197.027 101.696 196.801 101.696Z",
      fill: "#E8E6E1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M147.206 103.381C147.206 103.381 147.485 112.371 158.162 112.371C168.84 112.371 169.118 103.381 169.118 103.381H147.206Z",
      fill: "#DAD9D3"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M120.799 91.5826H137.093V88.2114H120.799V91.5826Z",
      fill: "#D3D1CB"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M58.0587 103.382H45.8849C45.061 103.382 44.3867 102.749 44.3867 101.977C44.3867 101.204 45.061 100.572 45.8849 100.572H58.0587C58.8825 100.572 59.5568 101.204 59.5568 101.977C59.5568 102.749 58.8825 103.382 58.0587 103.382Z",
      fill: "#E8E6E1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M58.0587 77.5358H45.8849C45.061 77.5358 44.3867 76.9036 44.3867 76.1312C44.3867 75.3582 45.061 74.7266 45.8849 74.7266H58.0587C58.8825 74.7266 59.5568 75.3582 59.5568 76.1312C59.5568 76.9036 58.8825 77.5358 58.0587 77.5358Z",
      fill: "#E8E6E1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M58.0587 129.227H45.8849C45.061 129.227 44.3867 128.595 44.3867 127.822C44.3867 127.05 45.061 126.417 45.8849 126.417H58.0587C58.8825 126.417 59.5568 127.05 59.5568 127.822C59.5568 128.595 58.8825 129.227 58.0587 129.227Z",
      fill: "#E8E6E1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M218 180.075C218 183.644 169.199 186.536 109 186.536C48.8009 186.536 0 183.644 0 180.075C0 176.506 48.8009 173.613 109 173.613C169.199 173.613 218 176.506 218 180.075Z",
      fill: "#E3ECFA"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M204.301 53.3763H149.106C146.207 53.3763 143.835 51.0296 143.835 48.1618V33.3072C143.835 30.4395 146.207 28.0928 149.106 28.0928H204.301C207.201 28.0928 209.572 30.4395 209.572 33.3072V48.1618C209.572 51.0296 207.201 53.3763 204.301 53.3763Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M193.477 35.3967H150.378C149.87 35.3967 149.454 34.9875 149.454 34.4877V33.4964C149.454 32.9965 149.87 32.5874 150.378 32.5874H193.477C193.986 32.5874 194.402 32.9965 194.402 33.4964V34.4877C194.402 34.9875 193.986 35.3967 193.477 35.3967Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M179.988 42.1394H150.383C149.872 42.1394 149.454 41.7302 149.454 41.2304V40.2385C149.454 39.7387 149.872 39.3301 150.383 39.3301H179.988C180.5 39.3301 180.918 39.7387 180.918 40.2385V41.2304C180.918 41.7302 180.5 42.1394 179.988 42.1394Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M172.119 48.8815H150.386C149.873 48.8815 149.454 48.473 149.454 47.9726V46.9812C149.454 46.4814 149.873 46.0723 150.386 46.0723H172.119C172.632 46.0723 173.052 46.4814 173.052 46.9812V47.9726C173.052 48.473 172.632 48.8815 172.119 48.8815Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M198.527 48.8815H176.794C176.281 48.8815 175.861 48.473 175.861 47.9726V46.9812C175.861 46.4814 176.281 46.0723 176.794 46.0723H198.527C199.04 46.0723 199.459 46.4814 199.459 46.9812V47.9726C199.459 48.473 199.04 48.8815 198.527 48.8815Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M192.926 35.3967H173.85C173.615 34.4573 173.349 33.5196 173.052 32.5874H192.926C193.429 32.5874 193.84 32.9965 193.84 33.4964V34.4877C193.84 34.9875 193.429 35.3967 192.926 35.3967Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M179.452 42.1394H175.085C174.998 41.2022 174.882 40.2656 174.737 39.3301H179.452C179.95 39.3301 180.356 39.7387 180.356 40.2385V41.2304C180.356 41.7302 179.95 42.1394 179.452 42.1394Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M198.527 48.8815H176.794C176.281 48.8815 175.861 48.473 175.861 47.9726V46.9812C175.861 46.4814 176.281 46.0723 176.794 46.0723H198.527C199.04 46.0723 199.459 46.4814 199.459 46.9812V47.9726C199.459 48.473 199.04 48.8815 198.527 48.8815Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M160.268 60.1185H97.6236C93.3741 60.1185 89.897 56.6252 89.897 52.3547V30.2379C89.897 25.9674 93.3741 22.4741 97.6236 22.4741H160.268C164.518 22.4741 167.995 25.9674 167.995 30.2379V52.3547C167.995 56.6252 164.518 60.1185 160.268 60.1185Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M162.148 32.5878H99.115C98.3715 32.5878 97.7627 32.0149 97.7627 31.3153V29.9272C97.7627 29.2271 98.3715 28.6548 99.115 28.6548H162.148C162.892 28.6548 163.5 29.2271 163.5 29.9272V31.3153C163.5 32.0149 162.892 32.5878 162.148 32.5878Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M142.474 42.7011H99.1239C98.3755 42.7011 97.7627 42.1287 97.7627 41.4291V40.0405C97.7627 39.3409 98.3755 38.7681 99.1239 38.7681H142.474C143.223 38.7681 143.835 39.3409 143.835 40.0405V41.4291C143.835 42.1287 143.223 42.7011 142.474 42.7011Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M130.682 52.8143H99.1171C98.3724 52.8143 97.7627 52.242 97.7627 51.5419V50.1538C97.7627 49.4542 98.3724 48.8813 99.1171 48.8813H130.682C131.427 48.8813 132.036 49.4542 132.036 50.1538V51.5419C132.036 52.242 131.427 52.8143 130.682 52.8143Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M164.945 52.8143H138.457C137.706 52.8143 137.093 52.242 137.093 51.5419V50.1538C137.093 49.4542 137.706 48.8813 138.457 48.8813H164.945C165.695 48.8813 166.309 49.4542 166.309 50.1538V51.5419C166.309 52.242 165.695 52.8143 164.945 52.8143Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M121.15 118.551H91.2303C89.2611 118.551 87.6494 116.931 87.6494 114.951V69.8991C87.6494 67.9195 89.2611 66.2988 91.2303 66.2988H121.15C123.121 66.2988 124.732 67.9195 124.732 69.8991V114.951C124.732 116.931 123.121 118.551 121.15 118.551Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M121.15 119.113H91.2303C89.2611 119.113 87.6494 117.481 87.6494 115.485V73.2794C88.3434 72.829 89.0362 72.3752 89.7269 71.9175C91.0072 73.9305 92.4208 75.8152 93.9504 77.5677H92.6026C92.2395 77.5677 91.9421 77.8695 91.9421 78.2374V79.2309C91.9421 79.5993 92.2395 79.9 92.6026 79.9H96.1328C97.302 81.067 98.5271 82.1639 99.8001 83.1885H92.6026C92.2395 83.1885 91.9421 83.4891 91.9421 83.8576V84.8517C91.9421 85.2196 92.2395 85.5208 92.6026 85.5208H102.965C104.8 86.7562 106.713 87.8531 108.691 88.8087H106.736C106.373 88.8087 106.075 89.1099 106.075 89.4778V90.4719C106.075 90.8398 106.373 91.1404 106.736 91.1404H114.494C117.808 92.2187 121.245 92.9212 124.732 93.2241V115.485C124.732 116.619 124.212 117.635 123.401 118.302C122.786 118.809 122.002 119.113 121.15 119.113Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M120.134 74.1649H92.8087C92.4435 74.1649 92.1445 73.8746 92.1445 73.5201V72.5628C92.1445 72.2077 92.4435 71.9175 92.8087 71.9175H120.134C120.5 71.9175 120.799 72.2077 120.799 72.5628V73.5201C120.799 73.8746 120.5 74.1649 120.134 74.1649Z",
      fill: "#F8F6F4"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M111.698 79.7836H92.8178C92.4476 79.7836 92.1445 79.4938 92.1445 79.1388V78.1814C92.1445 77.8269 92.4476 77.5361 92.8178 77.5361H111.698C112.068 77.5361 112.371 77.8269 112.371 78.1814V79.1388C112.371 79.4938 112.068 79.7836 111.698 79.7836Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M120.134 85.4022H92.8087C92.4435 85.4022 92.1445 85.112 92.1445 84.7574V83.7996C92.1445 83.4445 92.4435 83.1548 92.8087 83.1548H120.134C120.5 83.1548 120.799 83.4445 120.799 83.7996V84.7574C120.799 85.112 120.5 85.4022 120.134 85.4022Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M102.732 91.0209H92.7946C92.4372 91.0209 92.1445 90.7306 92.1445 90.3761V89.4182C92.1445 89.0637 92.4372 88.7734 92.7946 88.7734H102.732C103.089 88.7734 103.382 89.0637 103.382 89.4182V90.3761C103.382 90.7306 103.089 91.0209 102.732 91.0209Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M116.778 91.0209H106.841C106.484 91.0209 106.191 90.7311 106.191 90.3765V89.4184C106.191 89.0638 106.484 88.7734 106.841 88.7734H116.778C117.135 88.7734 117.428 89.0638 117.428 89.4184V90.3765C117.428 90.7311 117.135 91.0209 116.778 91.0209Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M120.134 96.639H92.8087C92.4435 96.639 92.1445 96.3493 92.1445 95.9943V95.0364C92.1445 94.6819 92.4435 94.3916 92.8087 94.3916H120.134C120.5 94.3916 120.799 94.6819 120.799 95.0364V95.9943C120.799 96.3493 120.5 96.639 120.134 96.639Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M120.134 102.258H92.8087C92.4435 102.258 92.1445 101.967 92.1445 101.613V100.656C92.1445 100.301 92.4435 100.01 92.8087 100.01H120.134C120.5 100.01 120.799 100.301 120.799 100.656V101.613C120.799 101.967 120.5 102.258 120.134 102.258Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M115.084 107.876H92.8028C92.4409 107.876 92.1445 107.586 92.1445 107.231V106.274C92.1445 105.919 92.4409 105.629 92.8028 105.629H115.084C115.446 105.629 115.742 105.919 115.742 106.274V107.231C115.742 107.586 115.446 107.876 115.084 107.876Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M103.28 113.495H92.8079C92.4432 113.495 92.1445 113.205 92.1445 112.85V111.892C92.1445 111.538 92.4432 111.248 92.8079 111.248H103.28C103.645 111.248 103.944 111.538 103.944 111.892V112.85C103.944 113.205 103.645 113.495 103.28 113.495Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M129.298 66.2988H87.6494L106.044 80.9561L134.283 91.5823V71.286C134.283 68.5432 132.041 66.2988 129.298 66.2988Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M127.278 76.9742H96.9019C96.4482 76.9742 96.0771 76.5825 96.0771 76.1037V74.4735C96.0771 73.9947 96.4482 73.603 96.9019 73.603H127.278C127.732 73.603 128.103 73.9947 128.103 74.4735V76.1037C128.103 76.5825 127.732 76.9742 127.278 76.9742Z",
      fill: "#F8F6F4"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M142.711 106.035V76.5692C142.711 74.3202 144.54 72.4795 146.776 72.4795H197.641C199.877 72.4795 201.706 74.3202 201.706 76.5692V106.035C201.706 108.284 199.877 110.124 197.641 110.124H146.776C144.54 110.124 142.711 108.284 142.711 106.035Z",
      fill: "#6D5DD3"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M151.701 96.4829V67.0174C151.701 64.7678 153.531 62.9277 155.766 62.9277H206.632C208.868 62.9277 210.696 64.7678 210.696 67.0174V96.4829C210.696 98.7325 208.868 100.572 206.632 100.572H155.766C153.531 100.572 151.701 98.7325 151.701 96.4829Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M206.845 100.479H168.814C168.924 99.0321 169.041 97.7027 169.147 96.4762H180.863C181.63 96.4762 182.257 95.8497 182.257 95.0834V81.2162C182.257 80.4498 181.63 79.8234 180.863 79.8234H173.879C174.237 79.4228 174.586 79.0053 174.927 78.5687C175.628 77.6102 176.305 76.5702 176.73 75.2398C176.939 74.5768 177.083 73.8228 177.036 72.9873C177.011 72.5715 176.931 72.1389 176.791 71.7169C176.721 71.5062 176.637 71.2989 176.538 71.0989L176.329 70.6904C175.3 68.6846 174.134 66.7462 172.803 64.9263C172.533 64.5527 172.259 64.1819 171.98 63.8144C172.099 63.5194 172.214 63.2245 172.327 62.9272H206.845C209.088 62.9272 210.923 64.7628 210.923 67.0069V96.3998C210.923 98.6438 209.088 100.479 206.845 100.479ZM185.431 86.3323C185.431 87.3318 186.249 88.1499 187.249 88.1499H203.927C204.926 88.1499 205.745 87.3318 205.745 86.3323V68.2411C205.745 67.2415 204.926 66.4235 203.927 66.4235H187.249C186.249 66.4235 185.431 67.2415 185.431 68.2411V86.3323ZM166.829 80.6048C166.785 80.5514 166.7 80.5205 166.604 80.5205C166.584 80.5205 166.565 80.5216 166.544 80.5244L166.522 80.5272C166.189 78.5478 165.918 76.7375 165.747 74.7502C167.332 72.6798 168.734 70.4874 169.943 68.2007C170.997 69.6177 171.986 71.0836 172.91 72.591L173.094 72.891L173.166 73.0152C173.208 73.1023 173.241 73.2029 173.264 73.3254C173.312 73.5686 173.307 73.9041 173.228 74.2816C173.069 75.0396 172.693 75.9217 172.207 76.7645C171.734 77.6236 171.159 78.472 170.535 79.294C170.404 79.4704 170.27 79.6468 170.133 79.8232H168.08C167.533 79.8232 167.056 80.1429 166.829 80.6048Z",
      fill: "#DE92EB"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M185.413 86.9401V68.694C185.413 67.6859 186.227 66.8608 187.223 66.8608H203.83C204.825 66.8608 205.639 67.6859 205.639 68.694V86.9401C205.639 87.9481 204.825 88.7732 203.83 88.7732H187.223C186.227 88.7732 185.413 87.9481 185.413 86.9401Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M203.83 88.7732H187.223C186.227 88.7732 185.413 87.9481 185.413 86.9401V68.694C185.413 67.6859 186.227 66.8608 187.223 66.8608H203.83C204.825 66.8608 205.639 67.6859 205.639 68.694V86.9401C205.639 87.9481 204.825 88.7732 203.83 88.7732Z",
      fill: "#FCEDFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M166.871 95.7911V81.755C166.871 80.9793 167.505 80.3452 168.279 80.3452H181.195C181.97 80.3452 182.603 80.9793 182.603 81.755V95.7911C182.603 96.5668 181.97 97.2009 181.195 97.2009H168.279C167.505 97.2009 166.871 96.5668 166.871 95.7911Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M180.906 96.9985H169.19C169.703 91.0895 170.002 87.5498 168.465 84.5478C168.981 84.4163 169.561 84.1983 170.021 83.8393L170.022 83.841C171.449 82.8038 172.737 81.6672 173.921 80.3457H180.906C181.672 80.3457 182.299 80.9722 182.299 81.7385V95.6057C182.299 96.3721 181.672 96.9985 180.906 96.9985ZM169.046 81.7367L167.065 81.4125L166.88 81.1389C166.877 81.1349 166.874 81.131 166.871 81.1276C167.099 80.6658 167.575 80.3461 168.122 80.3461H170.176C169.811 80.8175 169.428 81.285 169.046 81.7367Z",
      fill: "#FCEDFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M109 14.6083H148.33V8.98975H109V14.6083Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M41.5771 55.5847C41.0942 56.6915 40.5568 57.9287 40.0877 59.1235C39.6136 60.3313 39.1379 61.5397 38.714 62.7583C37.8447 65.1869 37.1045 67.6478 36.6243 70.0611L36.4639 70.9618L36.4077 71.304C36.3906 71.3966 36.389 71.5248 36.3757 71.6338C36.3504 72.1126 36.3608 72.6919 36.4099 73.2848C36.5135 74.478 36.6998 75.7525 36.9352 77.0303C37.4005 79.5877 37.9908 82.2258 38.5751 84.8188L35.7473 85.9639C34.4282 83.4862 33.3148 80.9717 32.3876 78.2861C31.9317 76.9416 31.5156 75.5655 31.2223 74.072C31.0768 73.3221 30.945 72.5474 30.9114 71.6665C30.9081 71.4367 30.896 71.2244 30.9053 70.9782C30.9142 70.7382 30.9246 70.4677 30.9445 70.3068L31.0525 69.1893C31.2234 67.7138 31.4792 66.2688 31.8094 64.8685C32.1197 63.4573 32.5171 62.0869 32.9388 60.7317C33.3655 59.3765 33.8357 58.0456 34.3571 56.7366C34.6157 56.0805 34.8852 55.4306 35.1641 54.7818C35.4425 54.1211 35.7258 53.5101 36.0665 52.8145L41.5771 55.5847Z",
      fill: "#ED975D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.7435 83.7163L41.0155 85.92L36.0616 88.2112C36.0616 88.2112 34.8592 86.1244 35.6889 84.2373L38.7435 83.7163Z",
      fill: "#E6776F"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M42.7013 89.2929L38.5434 91.0206L35.959 88.2882L40.8824 85.9639L42.7013 89.2929Z",
      fill: "#E6776F"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M134.402 82.5928V70.9237C134.402 68.5399 132.654 66.5365 130.351 66.0836L133.666 63.4897H141.807C141.111 65.3291 140.674 67.0354 140.674 67.0354L142.15 67.7389C141.959 68.2439 141.773 68.7511 141.589 69.2611C140.827 71.3549 140.119 73.4687 139.538 75.6745C139.463 75.9478 139.395 76.2277 139.329 76.5099L139.229 76.9318L139.176 77.1613C139.155 77.2699 139.131 77.3769 139.116 77.4883C138.972 78.3759 139.133 79.3598 139.511 80.1298C139.718 80.5478 139.955 80.912 140.211 81.2336C138.294 81.8467 136.351 82.2979 134.402 82.5928Z",
      fill: "#FEFCFB"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M143.437 60.0955H138.216L138.833 59.5797H143.835C143.7 59.7297 143.567 59.9033 143.437 60.0955Z",
      fill: "#F8F6F4"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M144.01 59.6865H138.778L147.23 52.9341H153.5C154.022 54.5893 153.994 56.2676 151.648 57.1632C149.611 57.6205 147.427 58.2818 146.07 58.715C145.664 58.81 145.223 58.9583 144.731 59.1555C144.486 59.2538 144.245 59.4381 144.01 59.6865ZM159.347 56.155C158.543 55.5673 158.146 54.3453 157.967 52.9339H164.847C164.988 52.9339 165.124 52.912 165.252 52.8715C165.066 53.9419 164.833 55.0032 164.553 56.0505C164.041 56.0342 163.458 56.023 162.83 56.023C161.756 56.023 160.552 56.0561 159.347 56.155ZM165.713 49.0641C165.478 48.8674 165.176 48.7489 164.847 48.7489H157.894C157.927 48.1078 157.969 47.5184 158 47.0273L156.431 48.7489H152.469L164.961 38.7681C165.526 41.3577 165.8 43.9714 165.799 46.5666C165.799 47.401 165.77 48.2348 165.713 49.0641Z",
      fill: "#66A4FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M164.824 53.0667H157.944C157.773 51.7155 157.803 50.19 157.87 48.8815H164.824C165.153 48.8815 165.455 49 165.69 49.1967C165.603 50.4766 165.448 51.7464 165.229 53.0044C165.101 53.0448 164.965 53.0667 164.824 53.0667ZM153.476 53.0666H147.206L152.445 48.8813H156.408L153.227 52.3722C153.318 52.602 153.402 52.834 153.476 53.0666Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M129.213 83.7164C123.761 83.7164 118.392 82.5029 113.495 80.2076L117.299 77.1483H127.962C128.423 77.1483 128.8 76.7691 128.8 76.3055V74.727C128.8 74.2634 128.423 73.8842 127.962 73.8842H121.358L130.79 66.2988C133.095 66.7647 134.845 68.8256 134.845 71.2776V83.2813C132.968 83.5732 131.086 83.7164 129.213 83.7164Z",
      fill: "#66A4FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M127.285 76.9742H116.866L120.832 73.603H127.285C127.735 73.603 128.103 73.9947 128.103 74.4735V76.1037C128.103 76.5825 127.735 76.9742 127.285 76.9742Z",
      fill: "#F8F6F4"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M101.43 66.0219H97.4117C96.7544 64.9724 96.1447 63.8812 95.5851 62.7474C95.3649 62.3013 95.1542 61.8524 94.9536 61.4018L97.2623 59.5566C97.3061 59.5578 97.3499 59.5578 97.3938 59.5578H104.478V63.5868L101.43 66.0219ZM104.619 63.474V59.5573H109.52L104.619 63.474Z",
      fill: "#FEFCFB"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M104.716 63.4896V59.5566H104.857V63.3799L104.716 63.4896Z",
      fill: "#E0DED8"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M156.196 21.9124H155.634V21.3506C155.824 21.5356 156.011 21.7225 156.196 21.9124Z",
      fill: "#EEEBE7"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M110.021 59.8921H97.8947C97.8508 59.8921 97.807 59.8921 97.7632 59.891L106.212 53.1397H118.472L110.021 59.8921ZM123.71 48.9543H111.45L118.834 43.0543H131.094L123.71 48.9543ZM136.332 38.8689H124.072L131.456 32.9694H143.716L136.332 38.8689ZM148.953 28.7843H136.694L144.591 22.4741H156.764C156.775 22.4876 156.788 22.5017 156.8 22.5151L148.953 28.7843Z",
      fill: "#66A4FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M143.116 32.5878H130.913L136.126 28.6548H148.33L143.116 32.5878Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M130.756 42.7011H118.552L123.765 38.7681H135.969L130.756 42.7011Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M118.395 52.8143H106.191L111.405 48.8813H123.608L118.395 52.8143Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M99.1397 68.5463C98.6607 67.8201 98.2004 67.0691 97.7627 66.2988H101.696L99.1397 68.5463Z",
      fill: "#66A4FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M104.857 21.9121H104.716V18.653C104.763 18.6155 104.809 18.578 104.857 18.541V21.9121Z",
      fill: "#E0DED8"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M111.458 21.9124H111.599V14.0464H111.458V21.9124Z",
      fill: "#E0DED8"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M133.16 15.1701V14.0464H134.283L133.16 15.1701Z",
      fill: "#F8F6F4"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M92.1681 48.3195C92.1524 47.8734 92.1445 47.4268 92.1445 46.9819C92.1479 38.0052 95.3866 29.2544 101.278 22.4741H124.17L116.298 28.8316H99.4033C98.6612 28.8316 98.0536 29.4452 98.0536 30.1958V31.684C98.0536 32.434 98.6612 33.0482 99.4033 33.0482H111.078L103.717 38.9919H99.4033C98.6612 38.9919 98.0536 39.6061 98.0536 40.3561V41.8448C98.0536 42.3458 98.3247 42.7862 98.7262 43.0234L92.1681 48.3195Z",
      fill: "#66A4FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M110.998 32.5878H99.1343C98.3802 32.5878 97.7627 32.0149 97.7627 31.3153V29.9272C97.7627 29.2271 98.3802 28.6548 99.1343 28.6548H116.304L110.998 32.5878Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M98.4299 42.7011C98.0316 42.4697 97.7627 42.04 97.7627 41.5513V40.0989C97.7627 39.3672 98.3655 38.7681 99.1016 38.7681H103.381L98.4299 42.7011Z",
      fill: "#E1EEFF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M144.959 73.0412C145.31 72.1051 145.671 71.168 146.038 70.2319C146.168 70.7694 146.307 71.3354 146.457 71.9308C146.518 72.1706 146.581 72.4152 146.645 72.6646H146.628C146.032 72.6646 145.465 72.7998 144.959 73.0412Z",
      fill: "#FEFCFB"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M143.564 80.3455C143.143 79.9113 142.839 79.4686 142.754 79.1313C142.692 78.8892 142.703 78.7388 142.752 78.5405L142.938 77.9081C143.011 77.6534 143.087 77.3982 143.171 77.1401C143.619 75.7248 144.107 74.3027 144.618 72.8795C145.132 72.6231 145.707 72.4795 146.313 72.4795H146.33C146.553 73.3843 146.797 74.3511 147.064 75.3807C147.094 75.4963 147.124 75.6137 147.155 75.7311V75.7305C147.347 76.4683 147.551 77.2369 147.768 78.0414C146.84 78.6339 145.878 79.1877 144.884 79.6999C144.447 79.925 144.005 80.1409 143.564 80.3455Z",
      fill: "#9787FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M134.209 14.0466H111.248C111.643 13.8311 112.042 13.6224 112.448 13.4195C117.697 10.7952 123.266 9.55176 128.748 9.55176C131.961 9.55176 135.143 9.97821 138.217 10.8037L134.209 14.0466Z",
      fill: "#66A4FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M94.9061 61.7516C94.5089 60.8594 94.151 59.961 93.8296 59.0547C94.8488 59.5806 95.9989 59.8862 97.2148 59.9065L94.9061 61.7516ZM127.389 22.4894H123.855L127.389 19.6655V22.4894Z",
      fill: "#FBFAF8"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M97.6092 59.8908C96.3934 59.8705 95.2432 59.5649 94.224 59.039C92.9554 55.4577 92.2755 51.7809 92.144 48.1272L98.7234 42.8705C98.9234 42.9873 99.1554 43.0542 99.4027 43.0542H118.68L111.297 48.9542H99.4027C98.6582 48.9542 98.0486 49.5639 98.0486 50.3083V51.7854C98.0486 52.5305 98.6582 53.1395 99.4027 53.1395H106.058L97.6092 59.8908ZM123.918 38.8689H103.731L111.115 32.9694H131.302L123.918 38.8689ZM136.54 28.7843H116.352L124.25 22.4741H144.437L136.54 28.7843Z",
      fill: "#87B8FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M131.323 32.5878H111.248L116.456 28.6548H136.531L131.323 32.5878Z",
      fill: "white"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M118.914 42.7011H99.5684C99.3203 42.7011 99.0874 42.6382 98.8867 42.5284L103.912 38.7681H124.17L118.914 42.7011Z",
      fill: "white"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M105.916 52.8143H99.1409C98.3832 52.8143 97.7627 52.242 97.7627 51.5419V50.1538C97.7627 49.4542 98.3832 48.8813 99.1409 48.8813H111.247L105.916 52.8143Z",
      fill: "white"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M146.083 14.6084H134.284L138.191 11.2373C140.932 12.0214 143.581 13.1528 146.083 14.6084Z",
      fill: "#87B8FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M138.448 59.8509H109.562L118.012 53.0985H130.655C131.4 53.0985 132.009 52.4895 132.009 51.7445V50.2673C132.009 49.5229 131.4 48.9133 130.655 48.9133H123.25L130.634 43.0132H142.221C142.966 43.0132 143.575 42.4042 143.575 41.6597V40.182C143.575 39.4376 142.966 38.828 142.221 38.828H135.872L143.256 32.9285H162.213C162.396 32.9285 162.57 32.892 162.729 32.8257C163.55 34.8315 164.182 36.8749 164.63 38.9325L152.138 48.9133H138.219C137.474 48.9133 136.865 49.5229 136.865 50.2673V51.7445C136.865 52.4895 137.474 53.0985 138.219 53.0985H146.899L138.448 59.8509ZM160.76 28.7433H148.494L156.34 22.4741C158 24.3709 159.485 26.4644 160.76 28.7433Z",
      fill: "#87B8FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M162.418 32.5878H143.273L148.563 28.6548H160.95C161.265 29.178 161.566 29.7113 161.855 30.2551C162.247 30.9948 162.608 31.7398 162.938 32.4912C162.778 32.5535 162.602 32.5878 162.418 32.5878Z",
      fill: "white"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M142.484 42.7011H130.913L136.143 38.7681H142.484C143.227 38.7681 143.835 39.3409 143.835 40.0405V41.4291C143.835 42.1287 143.227 42.7011 142.484 42.7011Z",
      fill: "white"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M130.677 52.8143H117.99L123.246 48.8813H130.677C131.425 48.8813 132.036 49.4542 132.036 50.1538V51.5419C132.036 52.242 131.425 52.8143 130.677 52.8143Z",
      fill: "white"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M147.059 52.8143H138.438C137.698 52.8143 137.093 52.242 137.093 51.5419V50.1538C137.093 49.4542 137.698 48.8813 138.438 48.8813H152.263L147.059 52.8143Z",
      fill: "white"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M113.109 80.1001C111.273 79.2455 109.504 78.2381 107.823 77.0857H116.882L113.109 80.1001ZM120.908 73.8698H103.775C101.987 72.2303 100.348 70.3998 98.8867 68.3856L101.498 66.2988H129.282C129.617 66.2988 129.945 66.3325 130.262 66.396L120.908 73.8698Z",
      fill: "#87B8FF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M116.838 76.9742H107.926C106.533 75.957 105.201 74.8316 103.943 73.603H120.799L116.838 76.9742Z",
      fill: "white"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M151.524 4.24682C149.697 3.26132 147.788 2.38707 145.847 1.6488L146.047 1.12402C148.01 1.87073 149.942 2.75509 151.791 3.75238L151.524 4.24682ZM89.9465 18.0297L89.4936 17.6971C94.0469 11.5094 100.142 6.41784 107.121 2.9731L107.369 3.47652C100.471 6.88193 94.4464 11.9145 89.9465 18.0297ZM83.1249 31.1449L82.5928 30.9645C83.5198 28.23 84.6874 25.573 86.0639 23.0682L86.5561 23.339C85.1959 25.8151 84.0418 28.4412 83.1249 31.1449Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M83.1208 30.9021L82.5928 30.7265C83.5127 28.0632 84.6713 25.4755 86.0373 23.0361L86.5258 23.2999C85.1759 25.7114 84.0307 28.269 83.1208 30.9021Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M90.3525 17.9792L89.897 17.6441C94.4767 11.4097 100.608 6.27979 107.627 2.80908L107.876 3.3163C103.58 5.44084 99.6216 8.19374 96.1546 11.4454C94.0224 13.4448 92.0761 15.6333 90.3525 17.9792Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M151.985 4.49467C150.086 3.4308 148.1 2.48703 146.083 1.69004L146.291 1.12354C148.331 1.92962 150.341 2.88431 152.263 3.96092L151.985 4.49467Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M36.9832 100.078C36.577 100.078 36.1584 100.055 35.728 100.007C34.8824 99.903 34.002 99.7283 32.9963 99.2996C30.2786 98.141 28.6509 95.4958 28.6548 92.7169C28.6554 92.132 28.7284 91.5415 28.8784 90.9577C29.1498 89.8986 29.5465 89.0935 29.978 88.3591C30.4151 87.6354 30.8972 87.0028 31.4236 86.4606C32.4698 85.3616 33.6856 84.607 34.9847 84.0199C36.4095 83.3327 37.8288 82.6332 39.2514 81.9405C39.1632 83.5204 39.1047 84.6958 39.1345 85.3627C42.3714 85.3627 54.5597 85.3627 61.2115 85.3627C61.9532 79.8717 62.4223 75.2021 62.6914 71.2388C66.4452 69.6336 70.2203 68.0733 74.0224 66.567C77.7087 65.114 81.4153 63.7015 85.169 62.3845C83.3239 57.2447 82.4373 51.9469 82.4362 46.7093C82.4317 29.507 91.9748 12.9598 108.443 4.83027C115.083 1.55297 122.125 0 129.061 0C146.262 0 162.809 9.54986 170.938 26.0173C174.219 32.664 175.772 39.7136 175.769 46.6554C175.769 49.0674 175.58 51.466 175.211 53.8303C174.869 56.0198 174.373 58.1807 173.728 60.2944C173.331 61.594 172.878 62.8756 172.37 64.1358C172.136 63.8285 171.898 63.524 171.654 63.2234L172.33 62.7053C172.33 62.7053 168.99 56.4637 166.797 56.2541C166.766 56.2513 166.736 56.2491 166.706 56.2468C166.456 56.2277 165.71 56.1755 164.679 56.1429C165.499 53.065 165.923 49.8765 165.925 46.6587C165.926 42.0026 165.04 37.2842 163.185 32.7534C162.857 31.9539 162.5 31.1611 162.112 30.3739C161.826 29.7952 161.527 29.2277 161.216 28.6709C158.62 24.03 155.148 20.1538 151.11 17.1484C149.673 16.0786 148.164 15.119 146.598 14.2745C144.037 12.8946 141.325 11.822 138.519 11.0787C135.452 10.2651 132.276 9.84483 129.069 9.84483C123.597 9.84483 118.039 11.0702 112.8 13.6565C112.395 13.8565 111.997 14.0621 111.602 14.2745C109.244 15.546 107.077 17.0428 105.116 18.7227C105.069 18.7626 105.022 18.8031 104.976 18.8435C96.8343 25.8909 92.2748 36.1318 92.2709 46.6863C92.2692 52.1632 93.4941 57.7251 96.0825 62.9683C102.498 75.9646 115.554 83.5013 129.128 83.5013C132.916 83.5013 136.745 82.9142 140.48 81.6949C141.177 82.5872 142.019 83.1574 142.809 83.6412C145.039 84.8885 147.254 85.4976 149.6 85.8583L149.852 84.8222C149.868 84.888 149.938 84.9363 150.031 84.9531C149.917 85.7066 149.728 86.9831 149.489 88.6451C147.292 89.7132 145.053 90.5925 142.788 91.2903C142.432 91.3999 142.076 91.5049 141.719 91.6055C141.214 91.7482 140.707 91.8819 140.199 92.0061C139.203 92.2511 138.205 92.4618 137.203 92.6388C134.521 93.1124 131.825 93.3445 129.145 93.3439C127.814 93.3439 126.487 93.2871 125.168 93.1737C121.655 92.8725 118.194 92.1741 114.856 91.1021C106.993 88.5777 99.7998 83.9783 94.1655 77.608C92.6249 75.8657 91.2011 73.9919 89.9117 71.9906C89.2161 72.4457 88.5183 72.8968 87.8193 73.3446C85.1719 75.0386 82.498 76.6798 79.8123 78.2963C74.909 81.2348 69.9534 84.0665 64.9585 86.8196C63.9466 87.3719 62.9347 87.922 61.9211 88.4704C61.4851 86.5224 61.2115 85.3627 61.2115 85.3627H53.3804C53.3804 85.3627 44.2766 85.3627 39.1345 85.3627C39.1345 89.471 39.734 94.3142 40.4094 99.4827C39.684 99.7406 38.9238 99.9272 38.1142 100.014C37.7479 100.057 37.3709 100.078 36.9832 100.078ZM149.555 83.5564C147.798 82.8119 146.02 81.9371 144.662 80.8696C144.437 80.696 144.227 80.5117 144.039 80.3257C144.493 80.124 144.947 79.9111 145.397 79.6891C146.42 79.184 147.409 78.6379 148.363 78.0536C148.798 79.5998 149.282 81.2741 149.82 83.085L149.764 83.0923C149.611 83.112 149.497 83.2024 149.497 83.2974C149.497 83.3064 149.498 83.3148 149.5 83.3238L149.555 83.5564ZM166.137 75.0711C166.009 73.58 165.936 71.9888 165.936 70.1515C165.936 68.9671 165.966 67.6799 166.03 66.2511C166.476 66.6905 166.784 66.9607 166.784 66.9607L166.785 66.9596L166.874 66.8916L168.216 65.8617C168.75 66.4916 169.278 67.1299 169.78 67.79C169.965 68.0328 170.15 68.2766 170.333 68.5216C169.124 70.8083 167.722 73.0007 166.137 75.0711Z",
      fill: "#F7C137"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M45.8679 37.6445C46.4536 40.6316 47.0376 46.1054 44.9482 48.0987C44.9482 48.0987 45.7645 51.1291 51.3142 51.1291C57.4162 51.1291 54.2304 48.0992 54.2304 48.0992C50.9002 47.3033 50.9858 44.832 51.5659 42.5109L45.8679 37.6445Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M42.6059 50.0051C43.2842 48.9328 42.1392 46.3365 42.1392 46.3365C42.1392 46.3365 52.256 43.7575 56.3893 47.7123C57.2472 48.5326 56.2943 49.7357 56.2943 49.7357L42.6059 50.0051Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M56.744 48.3195C56.0971 48.2303 55.416 48.151 54.7263 48.0936C53.6134 48.0007 52.1836 47.9652 50.6863 47.9652C48.787 47.9652 46.7791 48.0226 45.1731 48.093C44.3719 48.1285 43.5615 48.1896 42.7848 48.2637C42.6447 47.2873 42.1392 46.255 42.1392 46.255C42.1392 46.255 45.3802 45.5103 48.9426 45.5103C51.6746 45.5103 54.5953 45.9481 56.3888 47.4944C56.6553 47.7241 56.7474 47.9866 56.7474 48.2397C56.7468 48.2668 56.7463 48.2934 56.744 48.3195Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.4724 163.721C24.8837 164.193 25.5383 164.724 25.8215 164.656C25.8484 164.649 25.9316 164.63 25.9653 164.449C25.9799 164.372 25.9614 164.302 25.9091 164.233C25.686 163.94 24.9337 163.783 24.4724 163.721ZM25.7733 164.857C25.2497 164.857 24.4136 163.983 24.1675 163.656L24.1597 163.551L24.2535 163.5C24.3119 163.505 25.6896 163.624 26.0649 164.115C26.1509 164.228 26.1823 164.353 26.1576 164.486C26.111 164.738 25.9733 164.821 25.866 164.847L25.7733 164.857Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.4697 163.263C25.0001 163.284 25.8434 163.089 25.976 162.845C25.9878 162.823 26.0165 162.771 25.9277 162.678C25.8597 162.606 25.7749 162.572 25.6676 162.572H25.667C25.2962 162.572 24.7652 162.99 24.4697 163.263ZM24.5384 163.459C24.4209 163.459 24.317 163.451 24.2344 163.435L24.1597 163.369L24.1821 163.272C24.2175 163.234 25.048 162.376 25.6671 162.376H25.6677C25.8289 162.377 25.9643 162.433 26.0694 162.543C26.2324 162.714 26.1885 162.864 26.1475 162.939C25.9621 163.279 25.1008 163.459 24.5384 163.459Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M62.1974 177.157C62.9649 177.266 64.0088 177.259 64.2021 176.993C64.2268 176.958 64.2521 176.899 64.1824 176.777C64.1442 176.709 64.0813 176.664 63.9908 176.64C63.5689 176.524 62.7014 176.899 62.1974 177.157ZM63.1476 177.418C62.6543 177.418 62.1452 177.354 61.8817 177.302L61.8042 177.222L61.852 177.121C61.9126 177.086 63.3532 176.262 64.0421 176.451C64.1831 176.489 64.2876 176.566 64.3522 176.68C64.468 176.881 64.4208 177.023 64.3606 177.107C64.1893 177.345 63.6774 177.418 63.1476 177.418Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M62.9082 175.494C62.7846 175.494 62.6728 175.536 62.5689 175.621C62.2239 175.905 62.0767 176.57 62.0239 176.894C62.5324 176.588 63.2032 175.887 63.1577 175.607C63.1543 175.584 63.1431 175.515 62.9672 175.497L62.9082 175.494ZM61.9014 177.167L61.8441 177.149L61.8042 177.06C61.8087 177.013 61.9199 175.902 62.4447 175.47C62.6048 175.339 62.7874 175.282 62.9869 175.303C63.2555 175.33 63.333 175.467 63.351 175.576C63.4263 176.042 62.4397 176.935 61.9413 177.159L61.9014 177.167Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M57.3091 176.985H61.3966L61.8039 167.433H57.7158L57.3091 176.985Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.7886 160.746L24.2925 162.938L32.0257 156.703L28.5212 154.51L20.7886 160.746Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.6145 162.545L21.04 159.648C20.9101 159.542 20.7231 159.54 20.591 159.643L17.6452 161.931C17.3395 162.168 17.3429 162.63 17.6475 162.868C18.9129 163.858 19.5792 164.278 21.1509 165.552C22.1178 166.336 24.5227 168.725 25.8581 169.808C27.1644 170.867 28.4505 169.726 28.0015 169.164C25.9897 166.647 25.1772 164.491 24.9706 163.157C24.9331 162.916 24.8049 162.699 24.6145 162.545Z",
      fill: "#20282E"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M61.3396 176.984H56.8104C56.6411 176.984 56.4943 177.097 56.4576 177.255L55.6385 180.768C55.5532 181.133 55.8434 181.479 56.2346 181.472C57.8683 181.445 60.2292 181.354 62.2829 181.354C64.6838 181.354 66.7573 181.479 69.5731 181.479C71.2751 181.479 71.7482 179.838 71.0352 179.689C67.7909 179.013 65.1422 178.941 62.3382 177.292C62.0339 177.113 61.6975 176.984 61.3396 176.984Z",
      fill: "#20282E"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M36.9377 49.9086C33.4358 51.6141 31.4639 62.8242 31.4639 62.8242L40.0214 66.299C40.0214 66.299 41.9471 61.6589 43.0474 56.7072C44.2004 51.5196 40.5182 48.1645 36.9377 49.9086Z",
      fill: "#0A1629"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M41.1781 56.1023C39.0458 58.3116 38.071 62.64 37.6445 65.4548L39.7104 66.2988C39.7104 66.2988 41.5824 61.7727 42.7012 56.8676C42.5185 55.6661 42.0643 55.1846 41.1781 56.1023Z",
      fill: "#23273A"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M60.8908 49.6079C60.8908 49.6079 65.3065 54.5861 61.1359 85.4023C54.449 85.4023 42.1964 85.4023 38.9425 85.4023C38.79 82.0019 40.9301 65.4151 37.6445 49.3942C37.6445 49.3942 41.4486 48.6321 45.0736 48.4579C47.9095 48.3215 52.0152 48.2313 54.5083 48.4585C57.795 48.7572 60.8908 49.6079 60.8908 49.6079Z",
      fill: "#0A1629"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M62.354 61.5024L58.7531 55.062C58.0569 58.5898 57.761 60.7714 57.9078 64.2484C58.0052 66.4611 59.9607 74.654 61.7067 75.8507C62.2561 69.828 62.4139 65.1374 62.354 61.5024Z",
      fill: "#23273A"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M63.3924 53.938C63.9354 56.6397 64.509 59.4043 65.0987 62.1205C65.6878 64.8428 66.3069 67.554 67.0238 70.1841C67.2092 70.8315 67.3813 71.4961 67.5857 72.1224L67.7339 72.5991L67.8078 72.8375L67.7822 72.8086C67.7395 72.7603 67.6956 72.7553 67.7289 72.8053C67.7728 72.9164 68.1215 73.1576 68.5751 73.331C69.0343 73.5088 69.5962 73.6655 70.1915 73.7844C72.6007 74.2434 75.4386 74.3096 78.1316 74.3018L78.6596 77.3208C77.9139 77.5587 77.2176 77.7337 76.4875 77.9026C75.764 78.0738 75.0333 78.2211 74.2909 78.3333C72.8061 78.5628 71.2875 78.7095 69.6668 78.6439C68.8539 78.61 68.0132 78.5328 67.112 78.3116C66.2153 78.0799 65.2231 77.7654 64.1842 76.9513C63.6767 76.5451 63.1731 75.9827 62.8138 75.2987C62.7222 75.1348 62.6434 74.9442 62.5745 74.7841L62.2669 73.995C61.9826 73.2904 61.7494 72.5964 61.4946 71.8962C60.554 69.1027 59.7755 66.3149 59.0837 63.5142C58.4024 60.7046 57.8049 57.9195 57.3091 55.0471L63.3924 53.938Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M55.2436 52.7528C54.0988 56.579 58.7407 67.9846 58.7407 67.9846L67.9847 65.5883C67.9847 65.5883 67.6296 59.6629 65.5241 54.9592C62.3473 47.8638 56.6175 48.1598 55.2436 52.7528Z",
      fill: "#0A1629"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M77.9539 74.8462L82.5927 74.7266L80.3617 79.7762C80.3617 79.7762 78.4748 80.0388 76.924 77.371L75.2886 75.333L77.1694 74.9378C77.4276 74.8836 77.6902 74.8526 77.9539 74.8462Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M85.4019 75.6532L82.7984 79.7833L80.3452 79.7095L82.5317 74.7266L85.4019 75.6532Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M61.8039 167.433L61.5851 172.49H57.3091L57.5279 167.433H61.8039Z",
      fill: "#ED975D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M28.0466 154.51L31.4638 156.79L27.5769 160.129L24.1597 157.85L28.0466 154.51Z",
      fill: "#ED975D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M46.0832 34.695C46.332 38.8113 46.2688 41.2332 48.3403 43.3473C51.4565 46.5282 56.5257 44.6471 57.5085 40.5398C58.3936 36.8425 57.8385 30.7319 53.8213 29.0911C49.8634 27.4735 45.835 30.5792 46.0832 34.695Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M41.1457 33.9257C42.1685 37.6081 44.5776 41.8499 47.6912 42.1191C51.5607 42.4537 53.3072 38.5299 53.816 34.4752C56.1358 32.9167 54.9168 31.2046 57.2434 30.9865C60.2258 30.7068 59.2742 25.3478 55.342 24.4853C55.342 24.4853 56.6582 26.8995 53.8952 25.6819C51.1327 24.4637 48.4313 23.9409 45.45 24.2439C45.45 24.2439 48.9735 25.9727 45.5275 26.7441C42.0809 27.5156 41.049 29.6051 42.6355 30.8655C42.6355 30.8655 40.4718 31.5015 41.1457 33.9257Z",
      fill: "#233862"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M51.6953 35.4665C51.7629 36.5609 52.288 37.5904 52.9191 38.2639C53.8685 39.2768 54.8589 38.6463 55.0266 37.4118C55.1777 36.3014 54.866 34.4359 53.7056 33.8778C52.5618 33.3277 51.6183 34.2148 51.6953 35.4665Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M52.9867 85.4019C52.9867 85.4019 57.0189 114.47 53.8421 126.116C48.811 144.561 29.5611 160.129 29.5611 160.129L23.0361 155.871C23.0361 155.871 39.4262 142.724 41.433 127.287C43.2354 113.418 38.7099 96.6523 38.7099 85.4019C43.8632 85.4019 52.9867 85.4019 52.9867 85.4019Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.8713 158.443L25.2837 154.171C29.7923 150.049 40.1588 139.398 41.7339 127.355C42.0352 125.049 42.1611 122.662 42.1611 120.235C42.1611 113.368 41.1563 106.171 40.2774 99.5137C39.5953 94.3482 38.9899 89.5078 38.9899 85.4019C44.1828 85.4019 53.3765 85.4019 53.3765 85.4019H46.6295C46.6295 85.4019 49.4387 94.1589 51.8575 104.243C52.1707 109.796 52.4 116.133 52.4 122.093C52.4 125.633 52.3194 129.039 52.1276 132.069C52.2978 131.684 52.4624 131.297 52.6213 130.908C49.8137 137.788 45.3165 144.078 41.0519 149.055C38.2228 152.357 35.4958 155.08 33.4316 157.013C32.8557 157.553 32.332 158.031 31.8713 158.443Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M53.654 127.833C53.6563 127.826 53.6585 127.819 53.6608 127.811C53.658 127.819 53.6563 127.825 53.654 127.833Z",
      fill: "#2C5B99"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M53.572 128.094C53.6299 127.913 53.6872 127.732 53.7428 127.55C53.6872 127.732 53.6304 127.913 53.572 128.094Z",
      fill: "#2C5B99"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M53.6565 127.263C53.6571 127.262 53.6577 127.259 53.6582 127.258C53.6577 127.259 53.6571 127.262 53.6565 127.263Z",
      fill: "#2C5B99"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M54.5621 124.17C54.7385 123.299 54.8829 122.358 54.9998 121.361C54.9998 121.362 54.9998 121.361 54.9998 121.362C54.9391 121.879 54.8711 122.38 54.7953 122.865C54.7245 123.315 54.6469 123.751 54.5621 124.17Z",
      fill: "#2C5B99"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M54.6529 101.68C52.7588 99.5516 51.1289 98.3247 51.1289 98.3247C51.8146 107.706 52.3766 121.602 51.7528 131.474C52.5902 129.573 53.2984 127.617 53.8435 125.633C55.3891 119.98 55.2262 110.209 54.6529 101.68Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M51.976 132.036C52.1784 128.977 52.2635 125.538 52.2635 121.965C52.2635 115.947 52.0215 109.55 51.6909 103.943C53.1744 109.861 54.5189 116.231 55.0621 121.581C54.8596 123.26 54.5788 124.786 54.2038 126.095C54.0284 126.705 53.8367 127.313 53.6307 127.916C53.4409 128.471 53.239 129.022 53.0252 129.571C52.7018 130.401 52.3509 131.224 51.976 132.036Z",
      fill: "#2B73DF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M32.0257 158.974L29.5269 160.691L22.4741 155.87L24.6726 153.948L32.0257 158.974Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M29.5269 160.691L22.4741 155.87L24.6726 153.948L32.0257 158.974L29.5269 160.691Z",
      fill: "#264D90"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M61.2478 85.4019C61.2478 85.4019 67.5084 111.806 67.9497 124.419C68.4437 138.564 63.4827 171.928 63.4827 171.928H56.4414C56.4414 171.928 55.5746 138.304 55.2611 125.42C54.9199 111.374 46.6338 85.4019 46.6338 85.4019H61.2478Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M56.3769 169.118C56.1704 161.117 55.5225 135.993 55.2611 125.275C55.2334 124.146 55.1542 122.94 55.032 121.675C54.5188 116.382 53.2486 110.078 51.8471 104.223C49.4351 94.1496 46.6338 85.4019 46.6338 85.4019H61.2479C61.2479 85.4019 67.5085 111.71 67.9498 124.277C67.973 124.944 67.9843 125.655 67.9843 126.403C67.9843 126.661 67.9832 126.925 67.9803 127.192C67.9221 133.189 67.2165 141.32 66.3814 148.987C66.0815 151.737 65.7652 154.427 65.4563 156.937C65.2747 158.411 65.0953 159.822 64.9239 161.148C64.9177 161.194 64.9114 161.242 64.9052 161.288C64.5007 164.408 64.1374 167.038 63.8788 168.865L56.3769 169.118Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M64.6132 169.119L64.2249 171.928H55.8498L55.6235 169.42L64.6132 169.119Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M64.2249 171.928H55.8498L55.6235 169.42L64.6132 169.119L64.2249 171.928Z",
      fill: "#264D90"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M168.735 60.1187C169.22 60.568 169.597 60.9506 170 61.3803C170.39 61.8004 170.773 62.224 171.146 62.6548C171.89 63.5159 172.581 64.4153 173.25 65.3286C174.599 67.148 175.779 69.086 176.821 71.0913L177.033 71.4997C177.133 71.6997 177.219 71.9069 177.29 72.1176C177.431 72.5394 177.512 72.972 177.538 73.3876C177.584 74.2229 177.439 74.9768 177.228 75.6396C176.797 76.9697 176.111 78.0095 175.401 78.9678C173.918 80.8462 172.273 82.3657 170.39 83.7166L168.971 82.1101C169.642 81.345 170.334 80.5187 170.953 79.693C171.585 78.8712 172.167 78.023 172.646 77.1641C173.138 76.3215 173.52 75.4396 173.681 74.6819C173.76 74.3044 173.766 73.969 173.717 73.7258C173.694 73.6033 173.66 73.5028 173.618 73.4157L173.545 73.2916L173.358 72.9916C172.261 71.2239 171.072 69.5123 169.793 67.871C169.158 67.0464 168.481 66.2555 167.804 65.4724C167.466 65.0798 167.12 64.6961 166.772 64.3192C166.428 63.9563 166.05 63.5547 165.748 63.2542L168.735 60.1187Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M169.345 81.6433L165.186 80.9072L167.36 84.8402C167.36 84.8402 170.038 84.7405 170.804 83.0603L169.345 81.6433Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M161.814 82.5415L163.727 85.4021L166.871 84.4385L164.778 80.9072L161.814 82.5415Z",
      fill: "#E6776F"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M168.411 176.619L168.284 176.642C168.251 176.656 168.213 176.684 168.201 176.767C168.179 176.924 168.212 177.04 168.303 177.122C168.515 177.317 169.066 177.342 169.8 177.196C169.349 176.923 168.734 176.619 168.411 176.619ZM168.971 177.49C168.647 177.49 168.348 177.433 168.168 177.27C168.027 177.141 167.972 176.963 168.003 176.74C168.027 176.572 168.124 176.495 168.201 176.46C168.691 176.241 169.97 177.064 170.115 177.158L170.158 177.259L170.083 177.339C169.785 177.409 169.36 177.49 168.971 177.49Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M169.532 175.499L169.487 175.502C169.359 175.518 169.332 175.574 169.323 175.622C169.264 175.91 169.742 176.593 170.142 176.912C170.119 176.509 170.025 175.828 169.752 175.586C169.686 175.529 169.614 175.499 169.532 175.499ZM170.248 177.207L170.199 177.194C169.797 176.965 169.032 176.057 169.127 175.582C169.145 175.492 169.213 175.335 169.463 175.305C169.623 175.281 169.763 175.33 169.885 175.438C170.342 175.842 170.348 177.055 170.348 177.107L170.298 177.193L170.248 177.207Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M149.346 176.62C149.268 176.62 149.205 176.631 149.16 176.656C149.119 176.679 149.098 176.712 149.093 176.764C149.081 176.899 149.119 177.003 149.209 177.084C149.463 177.313 150.158 177.353 151.089 177.198C150.512 176.921 149.745 176.62 149.346 176.62ZM150.096 177.491C149.677 177.491 149.291 177.426 149.075 177.232C148.937 177.108 148.877 176.945 148.895 176.746C148.906 176.627 148.964 176.535 149.064 176.481C149.584 176.194 151.258 177.055 151.448 177.154L151.5 177.257L151.421 177.34C151.064 177.412 150.56 177.491 150.096 177.491Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M150.475 175.498L150.415 175.501C150.233 175.519 150.221 175.592 150.217 175.616C150.17 175.902 150.844 176.616 151.355 176.926C151.306 176.597 151.166 175.917 150.819 175.627C150.715 175.54 150.602 175.498 150.475 175.498ZM151.478 177.205L151.437 177.196C150.935 176.969 149.942 176.061 150.02 175.584C150.039 175.471 150.118 175.331 150.395 175.303C150.6 175.283 150.785 175.34 150.948 175.475C151.476 175.916 151.573 177.049 151.577 177.097L151.536 177.187L151.478 177.205Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M158.187 47.1958C158.022 49.722 157.57 54.8539 159.567 56.2717C159.567 56.2717 159.21 58.8589 154.495 59.4577C149.309 60.1158 151.68 57.2739 151.68 57.2739C154.421 56.2583 154.074 54.2298 153.323 52.3784L158.187 47.1958Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M155.634 176.985H151.421L151.139 167.433H155.353L155.634 176.985Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M175.299 176.985H171.048L169.681 167.433H173.932L175.299 176.985Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M170.749 176.423H175.531C175.706 176.423 175.847 176.549 175.871 176.727L176.416 180.68C176.473 181.09 176.135 181.478 175.734 181.471C174.066 181.441 173.263 181.339 171.16 181.339C169.866 181.339 167.976 181.48 166.189 181.48C164.442 181.48 164.307 179.633 165.051 179.466C168.387 178.716 168.914 177.683 170.038 176.696C170.241 176.518 170.495 176.423 170.749 176.423Z",
      fill: "#20282E"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M151.186 176.423H155.883C156.054 176.423 156.193 176.549 156.217 176.727L156.752 180.68C156.807 181.09 156.476 181.478 156.082 181.471C154.444 181.441 153.655 181.339 151.589 181.339C150.318 181.339 147.69 181.48 145.935 181.48C144.218 181.48 144.087 179.633 144.817 179.466C148.093 178.716 149.383 177.683 150.487 176.696C150.686 176.518 150.936 176.423 151.186 176.423Z",
      fill: "#20282E"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M151.139 167.433L151.288 172.49H155.634L155.486 167.433H151.139Z",
      fill: "#ED975D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M174.017 167.433H169.681L170.401 172.49H174.737L174.017 167.433Z",
      fill: "#ED975D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M157.692 41.9686C157.978 46.1838 158.188 47.9622 156.385 50.3849C153.673 54.0297 148.515 53.4643 146.994 49.4201C145.627 45.7804 145.389 39.4976 149.204 37.2982C152.963 35.1306 157.406 37.7527 157.692 41.9686Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M160.012 45.8425C162.34 47.156 164.062 43.9162 164.062 43.9162C164.062 43.9162 159.896 44.3746 160.268 41.8619C160.762 38.5293 158.406 34.4768 152.494 34.9958C152.167 35.0246 151.851 35.0659 151.544 35.1174C150.398 34.6324 148.846 34.6839 147.868 35.9748C146.215 36.1163 143.933 38.1445 145.465 40.8201C145.465 40.8201 145.599 40.3945 145.959 39.9893C146.085 41.5558 147.441 44.0458 149.127 44.2088C149.491 46.3558 148.084 48.8407 148.584 51.0783C149.305 54.3097 154.682 55.0618 154.682 55.0618C154.093 53.497 154.997 52.5706 154.997 52.5706C158.652 54.2604 161.059 52.6097 161.059 52.6097C158.569 51.6663 159.322 49.9923 159.322 49.9923C162.658 51.2815 164.062 48.2477 164.062 48.2477C162.286 48.3416 160.785 47.336 160.012 45.8425Z",
      fill: "#233862"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M150.576 44.6873C150.603 45.5424 150.231 46.3303 149.741 46.8347C149.002 47.5943 148.101 47.0638 147.86 46.0911C147.643 45.2156 147.766 43.7651 148.722 43.3695C149.663 42.98 150.545 43.7096 150.576 44.6873Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M154.51 83.659C154.51 83.659 155.567 111.323 158.071 127.57C160.094 140.692 169.065 171.366 169.065 171.366H174.737C174.737 171.366 170.063 141.743 169.036 128.763C166.438 95.9203 173.178 88.8704 166.835 82.0308L154.51 83.659Z",
      fill: "#0A1629"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M159.39 92.1551C159.39 92.1551 156.665 91.7078 155.072 96.6339C155.674 105.967 156.671 118.351 158.14 127.274C158.464 129.262 158.96 131.658 159.567 134.284C158.417 118.518 159.39 92.1551 159.39 92.1551Z",
      fill: "#010205"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M149.981 84.2137C149.981 84.2137 145.257 114.83 145.532 127.643C145.818 140.971 150.704 171.366 150.704 171.366H156.388C156.388 171.366 155.488 141.749 155.991 128.661C156.539 114.391 162.376 82.5928 162.376 82.5928L149.981 84.2137Z",
      fill: "#0A1629"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M175.861 171.928H168.043L167.433 169.119L175.807 169.183L175.861 171.928Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M175.861 171.928H168.043L167.433 169.119L175.807 169.183L175.861 171.928Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M166.443 56.198C168.617 56.4067 171.928 62.6224 171.928 62.6224L166.431 66.8608C166.431 66.8608 161.879 62.8485 162.421 60.5947C162.985 58.2475 164.354 55.9977 166.443 56.198Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M166.502 66.8995C166.502 66.8995 166.194 66.6292 165.747 66.1899C165.747 66.1893 165.747 66.1887 165.747 66.1882C166.192 66.6259 166.499 66.8961 166.502 66.8984L166.502 66.8995ZM166.592 66.8305L166.912 66.5839L165.936 62.924C166.073 60.9468 166.263 58.7246 166.514 56.1924C166.514 56.1924 166.483 56.1896 166.423 56.1851C166.453 56.1873 166.484 56.1896 166.514 56.1924C168.707 56.4019 172.047 62.6436 172.047 62.6436L171.372 63.1616L166.592 66.8305Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M164.817 58.6384C164.817 58.6384 163.936 58.3793 163.1 58.4432C162.809 59.053 162.584 59.7273 162.421 60.4119C161.877 62.7324 166.462 66.8609 166.462 66.8609L166.871 66.5385L164.817 58.6384Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M166.476 66.8607C166.476 66.8607 166.179 66.5933 165.748 66.158C165.791 65.1561 165.852 64.0847 165.93 62.9277L166.871 66.5494L166.476 66.8607Z",
      fill: "#264D90"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M148.192 64.5791C146.604 68.6137 144.93 72.7091 143.6 76.7526C143.514 77.0059 143.436 77.2563 143.362 77.5062L143.173 78.1267C143.122 78.3213 143.111 78.4688 143.174 78.7064C143.298 79.1805 143.883 79.8687 144.618 80.4389C146.105 81.6123 148.101 82.5509 150.016 83.3403L149.516 85.402C147.189 85.0431 144.992 84.4371 142.78 83.196C141.711 82.5386 140.543 81.7213 139.781 80.1465C139.408 79.37 139.25 78.3777 139.392 77.4827C139.407 77.3703 139.43 77.2624 139.45 77.1529L139.503 76.9214L139.601 76.496C139.666 76.2115 139.733 75.9292 139.807 75.6536C140.379 73.4292 141.076 71.2976 141.826 69.1861C142.57 67.0696 143.366 65.0006 144.253 62.9277L148.192 64.5791Z",
      fill: "#FFB27D"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M144.623 59.3207C144.623 59.3207 142.726 60.2823 149.915 84.2783C156.644 83.3971 163.597 82.4867 166.871 82.0582C165.684 75.1887 165.119 70.9307 166.564 56.3245C166.564 56.3245 162.911 56.0164 159.24 56.3178C156.369 56.554 154.019 56.7688 151.541 57.3266C148.273 58.0616 144.623 59.3207 144.623 59.3207Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M149.72 83.1546C148.903 80.4151 148.211 77.9914 147.625 75.8446L147.746 70.7398L148.078 70.9011C148.078 70.9011 150.429 65.0114 150.427 61.9213C150.426 61.2314 150.308 60.6808 150.02 60.3667C149.006 59.2616 148.157 58.7497 147.084 58.7497C146.772 58.7497 146.442 58.793 146.083 58.8773C147.444 58.4441 149.636 57.7828 151.679 57.3255C154.166 56.7682 156.524 56.5535 159.405 56.3176C160.615 56.2187 161.823 56.1855 162.901 56.1855C165.102 56.1855 166.755 56.3243 166.755 56.3243C166.504 58.8565 166.312 61.0785 166.175 63.0556C166.094 64.2248 166.031 65.3075 165.985 66.3199C165.985 66.3204 165.985 66.321 165.985 66.3216C165.922 67.7503 165.892 69.0375 165.892 70.2218C165.892 74.508 166.285 77.4537 166.871 80.918L149.72 83.1546Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M147.768 75.2886C147.348 74.0696 146.975 72.9471 146.645 71.9175C146.975 72.9476 147.348 74.0685 147.768 75.2886Z",
      fill: "#2C5B99"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M167.019 80.9984L167.973 82.3525C168.047 82.4572 167.925 82.5897 167.73 82.6139L150.114 84.8364C149.962 84.8557 149.827 84.7999 149.805 84.7092L149.457 83.2783C149.433 83.1796 149.552 83.0776 149.718 83.0572L166.729 80.9109C166.854 80.8953 166.972 80.9302 167.019 80.9984Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M150.055 84.8402C149.929 84.8402 149.825 84.7882 149.805 84.7093L149.511 83.5006L149.457 83.2784C149.455 83.2698 149.454 83.2618 149.454 83.2532C149.454 83.1625 149.567 83.0761 149.718 83.0573L166.729 80.911C166.749 80.9083 166.768 80.9072 166.788 80.9072C166.889 80.9072 166.978 80.941 167.019 80.9985L167.973 82.3526C167.988 82.3735 167.994 82.3955 167.995 82.4175C167.995 82.5061 167.886 82.5946 167.73 82.614L150.114 84.8365C150.094 84.8391 150.074 84.8402 150.055 84.8402Z",
      fill: "#233862"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M164.652 83.1524L165.059 83.0909C165.14 83.0789 165.196 83.0219 165.184 82.9643L164.765 80.9921C164.753 80.9346 164.677 80.8975 164.596 80.9095L164.189 80.9705C164.108 80.983 164.051 81.04 164.064 81.0976L164.483 83.0692C164.495 83.1268 164.571 83.1644 164.652 83.1524Z",
      fill: "#0A1629"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M153.415 84.8378L153.822 84.7768C153.903 84.7648 153.959 84.7078 153.947 84.6497L153.527 82.6782C153.516 82.6206 153.439 82.583 153.358 82.595L152.952 82.6566C152.871 82.6685 152.814 82.7255 152.826 82.7837L153.246 84.7551C153.258 84.8127 153.334 84.8503 153.415 84.8378Z",
      fill: "#0A1629"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M145.521 67.2906C145.978 69.5027 146.639 72.3039 147.564 75.8505L147.768 66.8608L145.521 67.2906Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M147.644 75.8503C147.012 73.4808 146.497 71.4359 146.083 69.6699L147.768 70.5047L147.644 75.8497V75.8503Z",
      fill: "#2B73DF"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M144.367 59.0107C142.266 59.8714 140.464 67.2064 140.464 67.2064L147.684 70.7939C147.684 70.7939 151.178 61.826 149.612 60.0777C147.981 58.2574 146.784 58.0208 144.367 59.0107Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M147.684 70.7939L147.353 70.6299L140.464 67.2065C140.464 67.2065 142.266 59.8716 144.367 59.0109C145.291 58.6326 146.036 58.4331 146.696 58.4331C147.762 58.4331 148.605 58.9538 149.611 60.0779C149.897 60.3974 150.014 60.9575 150.015 61.6593C150.018 64.8027 147.684 70.7939 147.684 70.7939Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M157.051 171.928H149.482L148.892 169.119L157.319 169.183L157.051 171.928Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M157.051 171.928H149.482L148.892 169.119L157.319 169.183L157.051 171.928Z",
      fill: "#02A1D1"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M150.089 82.9295L149.516 82.6662C148.899 82.383 148.24 82.9594 148.34 83.6964L148.755 86.7524C148.843 87.4027 149.443 87.8137 149.995 87.5862C150.184 87.5076 150.381 87.3939 150.571 87.228C150.964 86.8844 151.161 86.3285 151.137 85.7715L151.084 84.5056C151.054 83.809 150.667 83.1945 150.089 82.9295Z",
      fill: "#FFB27D"
    })
  ])
], -1)
const _hoisted_3 = { class: "p-text-secondary" }
const _hoisted_4 = { class: "p-p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("h5", null, _toDisplayString(_ctx.$t("datasource.label.empty.title")), 1),
    _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("datasource.label.empty.description")), 1),
    _createVNode("div", _hoisted_4, [
      (_ctx.canEdit())
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "pi pi-plus",
            label: _ctx.$t('button.create_datasource'),
            onClick: _ctx.createDatasource
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}